export const mockProducts =  [
    { name: 'Pinar Süt', price: 39.00 },
    { name: 'Uno Ekmek', price: 49.50 },
    { name: 'AOC Terayagi', price: 369.90 },
    { name: 'Eker Yogurt', price: 86.90 },
    { name: 'Tost Peyniri', price: 147.90 },
    { name: 'Kangal Sucuk', price: 79.90 },
    { name: 'Ceviz', price: 199.90 },
    { name: 'Colgate Dis Fircasi', price: 99.10 },
    { name: 'Selpak Mendil', price: 55.90 },
    { name: 'Aycicek Yagi', price: 399.5 },
    { name: 'Muz', price: 89.95 },
    { name: 'Tamek Portakal Suyu', price: 66.5 },
    { name: 'Coca-Cola 1L', price: 40.00 },
    { name: 'Assu 5L', price: 23.50 },
    { name: 'Dido Cikolata', price: 20.00 },
    { name: 'Cipso', price: 35.50 },
    { name: 'Torku Toz Seker', price: 234.95 },
    { name: 'Baldo Pirinc', price: 159.95 },
    { name: 'Pastavilla Makarna', price: 24.50 },
    { name: 'Tat Salca', price: 101.95 },
    { name: 'Nescafe Classic 100G', price: 225.9 },
];